<template>
  <div id="app">
    <appNav />
    <mastHead />
    <router-view></router-view>
    <appFooter />
  </div>
</template>

<script>
import appNav from "./components/appNav.vue";
import mastHead from "./components/mastHead.vue";
import appFooter from "./components/footer.vue";

export default {
  name: "App",

  components: {
    appNav,
    mastHead,
    appFooter,
  },

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "blackmondayradio.nl - Metal op de radio ! - Home",
  },

  data: function () {
    return {};
  },

  methods: {
    insertMixcloudFooterPlayer: function () {
      // Mixcloud footer player
    //   let script = document.createElement("script");
    //   script.setAttribute(
    //     "src",
    //     "https://widget.mixcloud.com/media/js/footerWidgetApi.js"
    //   );
    //   //script.setAttribute("async", "async");
    //   // script.innerHTML =
    //   //   '{"feed": "/BlackMondayRadioshow/black-monday-get-out-of-bed-hour-22-10-2018-with-dj-tim/"}';
    //   document.head.appendChild(script);
    },
  },

  mounted: function () {
    this.insertMixcloudFooterPlayer();

    // touch
    var touchDevice = ('ontouchstart' in document.documentElement);
    if (touchDevice) {
      document.documentElement.className += " touch";
    }

  },
};
</script>

<style src="./static/style.css"></style>

<style>
.form-control:focus {
  border-color: rgba(33, 37, 41) !important;
  outline: 0;
  box-shadow: 0 0 0 0.2rem #c0c0c0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.badge-primary {
  background-color: #e35313 !important;
}

::-moz-selection {
  background: #e35313;
  text-shadow: none;
}

::selection {
  background: #e35313;
  text-shadow: none;
}

section a {
  color: #e35313 !important;
  letter-spacing: 2px;
}

#liveplayer {
  visibility: hidden;
}
</style>
